import { use } from 'react';

import type { FiltersContextValue } from './filters-context';
import { FiltersContext } from './filters-context';

export function useFiltersContext() {
  const ctx = use(FiltersContext);
  if (!ctx) throw new Error('useFiltersContext must be used within FiltersContextWithAccordion');
  return ctx as FiltersContextValue;
}
